import { useHoveredSourceStore } from "#features/conversations/stores/useHoveredSourceStore.ts";
import { useCallback, useMemo } from "react";

/** Hover state keyed on the source (see getSourceKey), so every pill and row for one source lights together. */
export const useHoveredSource = (sourceKey: string) => {
    const { hoveredSourceKey, setHoveredSourceKey } = useHoveredSourceStore();

    const onMouseEnter = useCallback(() => {
        setHoveredSourceKey(sourceKey);
    }, [setHoveredSourceKey, sourceKey]);

    const onMouseLeave = useCallback(() => {
        setHoveredSourceKey(null);
    }, [setHoveredSourceKey]);

    const isHovered = useMemo(() => {
        return hoveredSourceKey === sourceKey;
    }, [hoveredSourceKey, sourceKey]);

    return {
        isHovered,
        onMouseEnter,
        onMouseLeave
    };
};
